var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFwUpgradeProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.9811C13.3562 13.7257 16 10.9216 16 7.5C16 3.91015 13.0899 1 9.5 1C6.06246 1 3.24817 3.66844 3.01555 7.04691C2.64009 7.12063 2.29478 7.2784 2 7.49982C2.0001 3.35777 5.35792 0 9.5 0C13.6421 0 17 3.35786 17 7.5C17 11.4741 13.909 14.7263 10 14.9836V13.9811ZM9.99194 3.41012C9.94961 3.17688 9.74546 3 9.5 3C9.22386 3 9 3.22386 9 3.5V7.5L9.00806 7.58988C9.05039 7.82312 9.25454 8 9.5 8H12.5L12.5899 7.99194C12.8231 7.94961 13 7.74546 13 7.5C13 7.22386 12.7761 7 12.5 7H10V3.5L9.99194 3.41012ZM2 10V9.5C2 8.67157 2.67157 8 3.5 8H5.5C6.32843 8 7 8.67157 7 9.5V10H7.5C8.32843 10 9 10.6716 9 11.5V13H7V12.5C7 12.2239 6.77614 12 6.5 12C6.22386 12 6 12.2239 6 12.5V13H3V12.5C3 12.2239 2.77614 12 2.5 12C2.22386 12 2 12.2239 2 12.5V13H0V11.5C0 10.6716 0.671573 10 1.5 10H2ZM3 9.5V10H6V9.5C6 9.22386 5.77614 9 5.5 9H3.5C3.22386 9 3 9.22386 3 9.5ZM7 14H9V15.5C9 16.3284 8.32843 17 7.5 17H1.5C0.671573 17 0 16.3284 0 15.5V14H2V14.5C2 14.7761 2.22386 15 2.5 15C2.77614 15 3 14.7761 3 14.5V14H6V14.5C6 14.7761 6.22386 15 6.5 15C6.77614 15 7 14.7761 7 14.5V14Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwUpgradeProgressIcon);
export default __webpack_public_path__ + "static/media/FWUpgradeProgressIcon.b75257ead0ed811f6d04da6c032bf353.svg";
export { ForwardRef as ReactComponent };